export const CUSTOMER_QUOTATION_TYPE = "customer-quotation";
export const DOCUMENT_CUSTOMER_QUOTATION_SLUG = "document-customer-quotation";

export const DOCUMENT_TYPE_TO_SLUG_MAP = {
    [CUSTOMER_QUOTATION_TYPE]: DOCUMENT_CUSTOMER_QUOTATION_SLUG,
};

export const DOCUMENT_SLUG_TO_TYPE_MAP = {
    [DOCUMENT_CUSTOMER_QUOTATION_SLUG]: CUSTOMER_QUOTATION_TYPE,
};

export const DOCUMENT_TYPE_TO_PERMISSION_GROUP_MAP = Object.freeze({
    [CUSTOMER_QUOTATION_TYPE]: CUSTOMER_QUOTATION_TYPE,
});

const buildSlugPermissionGroupMap = () => {
    const permissionMap = {};
    Object.entries(DOCUMENT_SLUG_TO_TYPE_MAP).forEach(([slug, type]) => {
        const permissionGroup = DOCUMENT_TYPE_TO_PERMISSION_GROUP_MAP[type];
        if (permissionGroup) {
            permissionMap[slug] = permissionGroup;
        }
    });
    return permissionMap;
};

export const DOCUMENT_SLUG_TO_PERMISSION_GROUP_MAP = Object.freeze(buildSlugPermissionGroupMap());

export const resolveDocumentTypeFromSlug = (slug) => {
    if (!slug) {
        return null;
    }
    return DOCUMENT_SLUG_TO_TYPE_MAP[slug] ?? slug;
};

export const resolveDocumentSlugFromType = (type) => {
    if (!type) {
        return null;
    }
    return DOCUMENT_TYPE_TO_SLUG_MAP[type] ?? type;
};

export const resolveDocumentPermissionGroupFromType = (type) => {
    if (!type) {
        return null;
    }
    return DOCUMENT_TYPE_TO_PERMISSION_GROUP_MAP[type] ?? null;
};

export const resolveDocumentPermissionGroupFromSlug = (slug) => {
    if (!slug) {
        return null;
    }
    if (DOCUMENT_SLUG_TO_PERMISSION_GROUP_MAP[slug]) {
        return DOCUMENT_SLUG_TO_PERMISSION_GROUP_MAP[slug];
    }
    const resolvedType = resolveDocumentTypeFromSlug(slug);
    return resolveDocumentPermissionGroupFromType(resolvedType);
};

export const resolveDocumentPermissionGroup = ({type = null, slug = null} = {}) => (
    resolveDocumentPermissionGroupFromType(type) ?? resolveDocumentPermissionGroupFromSlug(slug) ?? null
);

export const DOCUMENT_HEADER_Z_INDEX_CLASS = "z-20";
export const DOCUMENT_SYSTEM_TASKS_PANEL_Z_INDEX_CLASS = "z-[100]";
export const DOCUMENT_PANEL_Z_INDEX_CLASS = "z-[90]";
export const DOCUMENT_PANEL_OVERLAY_Z_INDEX_CLASS = "z-[0]";
export const DOCUMENT_REPORT_VIEWER_Z_INDEX_CLASS = "z-[160]";
export const DOCUMENT_EXPORT_OPTIONS_MODAL_Z_INDEX_CLASS = "z-[200]";
export const DOCUMENT_BODY_OVERLAY_Z_INDEX_CLASS = "z-10";
export const DOCUMENT_PORTAL_DROPDOWN_Z_INDEX_CLASS = "z-[1000]";
export const DOCUMENT_DATE_PICKER_POPPER_Z_INDEX_CLASS = "z-[9999]";
export const DOCUMENT_DIMENSIONS_SELECT_MENU_Z_INDEX = 40;
export const DOCUMENT_TABLE_TOOLBAR_Z_INDEX = 50;
